// Fallback de mídia por nome do exercício.
// Se o ExerciseItem não tiver demo_url, tentamos mapear pelo nome normalizado.
// Espera os arquivos em /uploads/media/ servidos pelo backend (REACT_APP_API_URL).

function slug(s){
  return String(s||"")
    .normalize('NFD').replace(/\p{Diacritic}/gu,'')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g,'_')
    .replace(/^_|_$/g,'');
}

export const EXERCISE_MEDIA_MAP = {
  // exemplos iniciais — basta colocar os GIFs/MP4/WEBM em uploads/media com esses nomes
  triceps_corda: 'uploads/media/triceps_corda.gif',
  supino_com_barra: 'uploads/media/supino_barra.gif',
  extensao_de_um_braco_com_halteres: 'uploads/media/extensao_um_braco_halteres.gif',
  abducao_no_cross: 'uploads/media/abducao_no_cross.svg',
  afundo_bulgaro: 'uploads/media/afundo_bulgaro.svg',
};

export function getMediaForExerciseName(name){
  const key = slug(name)
    .replace(/de_/g,'')
    .replace(/com_/g,'');

  if (EXERCISE_MEDIA_MAP[key]) return EXERCISE_MEDIA_MAP[key];

  // tentativas extras
  const alt = key
    .replace(/coice_na_polia/g,'triceps_coice_na_polia')
    .replace(/supino_/g,'supino_');

  return EXERCISE_MEDIA_MAP[alt] || null;
}
